/**
 * An Application plugin.
 *
 * Represents an independent module of the system.
 *
 * It usually publishes some API methods to application when constructing.
 *
 * To be descended with business logic.
 *
 * @see ./Application.js
 *
 */
export default class Plugin {

    constructor(id, app, config) {

        this._config = ({...config});

        this.id = id;

        this.app = app;
    }

    /**
     *  Initializes the plugin.
     *
     *  Invoked from Application.init()
     *
     *  May return promise.
     */
    init() {}

    /**
     *  Finalizes the plugin.
     *
     *  Invoked from Application.done()
     */
    done() {}

    //////////////////////
    // Routines
    /////////////////////

    /**
     * resolves plugin dependencies.
     */
    resolveDependencies(plugins, deps=[]) {

        // check if depending plugin id exists
        deps.forEach(dep => {

            if (!plugins.has(dep)) {

                throw new Error(`Can't init plugin ${plugin.id}: lack of depending plugin ${dep}`);
            }
        });
    }

    /**
     * Gets configuration value by key.
     *
     * @param key
     * @return config value by given `key` or null.
     */
    config(key) {

        return key && this._config[key] || null;
    }

    /**
     * Gets string representation of plugin.
     */
    toString() {

        return this.id;
    }

}